import script from "./inputText.vue?vue&type=script&setup=true&lang=js"
export * from "./inputText.vue?vue&type=script&setup=true&lang=js"

import "./inputText.vue?vue&type=style&index=0&id=0da910d7&lang=scss&scoped=true"

import exportComponent from "D:\\a-mydemo\\houlang\\gs-demo\\keymemo-demo\\keymemory-pc-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0da910d7"]])

export default __exports__